'use client';

import { useDecisions } from '../../hooks';
import { LocalAdLegacy } from './LocalAd.legacy';
import { LocalAdV2 } from './LocalAd.v2';

type LocalAdScriptsProps = {
    onDone: () => void;
};

export const LocalAdScripts = (props: LocalAdScriptsProps) => {
    const isOneTrust = useDecisions('onetrust');

    return isOneTrust ? <LocalAdV2 {...props} /> : <LocalAdLegacy {...props} />;
};
